import React, { FC, useEffect } from 'react';

import { Grid } from '@mui/material';
import { FormikProps } from 'formik';

import { adminOwnersList, getOwnersList } from '@pharmaplan/common';
import { dropdownMapper } from '@pharmaplan/common/helpers/utils';

import { ownershipDropdown } from '../../../../../helpers/Constants';
import { useAppDispatch } from '../../../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../../../hooks/useAppSelector';
import useAdmin from '../../../../../hooks/useAdmin';
import CustomDropdown from '../../../../common/CustomDropdown';
import strings from '../../../../../localization';

import styles from '../style';

interface IOwnershipFilters {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikProps<any>;
  isOwnership: boolean;
}

const OwnershipFilters: FC<IOwnershipFilters> = ({ formik, isOwnership }) => {
  const dispatch = useAppDispatch();
  const { isSuperAdmin } = useAdmin();

  const owners = useAppSelector(adminOwnersList);

  const ownerMenuItems = [
    { key: '', label: strings.all },
    ...dropdownMapper(owners, isOwnership ? 'userId' : 'userName', 'userName'),
  ];

  useEffect(() => {
    if (isSuperAdmin) {
      dispatch(getOwnersList());
    }
  }, [dispatch, isSuperAdmin]);

  return (
    <>
      {!isOwnership && (
        <Grid item xs={5} sx={styles.container}>
          <CustomDropdown
            label={strings.ownership}
            menuItems={ownershipDropdown()}
            formik={formik}
            name="ownership"
          />
        </Grid>
      )}

      {isSuperAdmin && (
        <Grid item xs={5} sx={styles.container}>
          <CustomDropdown
            label={strings.ownerName}
            menuItems={ownerMenuItems}
            formik={formik}
            name={isOwnership ? 'ownerId' : 'adminName'}
          />
        </Grid>
      )}
    </>
  );
};

export default OwnershipFilters;
